import {doppeActionTypeDefineViewerMetadata} from "../../client-server-common/doppe-action-types/doppe-action-type";
import React from "react";
import {doppeActionTypeBlogPost} from "./doppe-action-type-blog-post";

export const doppeActionTypeBlogPostViewer = doppeActionTypeDefineViewerMetadata(doppeActionTypeBlogPost, {

    loadViewerComponents: async () => {
        return {
            DoppeActionTypeBlogPostWidget: (await import('./doppe-action-type-blog-post-widget/doppe-action-type-blog-post-widget')).DoppeActionTypeBlogPostWidget
        }
    },

    renderWidget: (renderProps, viewerComponents) => {

        const {
            DoppeActionTypeBlogPostWidget
        } = viewerComponents;

        return (
            <DoppeActionTypeBlogPostWidget
                {...renderProps}
            />
        );
    },

    activateCTA: actionContext => {
        actionContext.navigateToUrl(actionContext.action.settings.blogPostLink, true);
    }
})